import * as React from 'react';
import { connect } from 'react-redux';
import { logIn } from '../thunks';
import { RootState } from '../types';

import './LoginPage.css';

interface IProps {
    isLoading: boolean,
    error: string | null,
    onLogIn: (username: string, password: string) => any,
}

export class LoginPage extends React.Component<IProps> {
    private email: HTMLInputElement | null;
    private password: HTMLInputElement | null;

    public render() {
        const {
            error,
            isLoading,
        } = this.props;
        return (<div className="container">
            <form className="login-form" onSubmit={this.onSubmit}>
                <input ref={ref => this.email = ref} placeholder="email" /><br />
                <input ref={ref => this.password = ref} placeholder="password" type="password" /><br />
                <input disabled={isLoading} type="submit" value="Log In" />
                <div className="feedback">
                {
                    isLoading
                        ? 'Loading...'
                        : (error || '')}
                </div>
            </form>
        </div>);
    }

    private onSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();

        if (!this.email || !this.password) {
            return;
        }
        const email = this.email.value;
        const password = this.password.value;

        this.props.onLogIn(email, password);
    }
}

export const LoginPageContainer = connect(
    ({auth}: RootState) => ({
        error: auth.loginError,
        isLoading: auth.isLoading,
    }),
    dispatch => ({
        onLogIn: (username: string, password: string) => dispatch<any>(logIn(username, password)),
    }),
  )(LoginPage)

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.tsx